<!---->


<!-- -->
<div [dir]="'dir'| translate" class="third-layout-container">
    <btx-third-empty-header></btx-third-empty-header>
    <!--    -->
    <div class="third-layout-content">
        <router-outlet></router-outlet>
        <!--    -->
    </div>

    <div class="push"></div>
</div>
<btx-third-empty-footer id="footer"></btx-third-empty-footer>